@import "../../styles/constants.scss";

.collapse-wrapper {
  --collapse-toggle-height: 52px;

  width: 100%;
  border: var(--border-style);

  > .collapse-toggle {
    display: flex;
    align-items: center;
    font-size: var(--font-size-s);
    color: var(--collapse-title-color);
    font-weight: 500;
    height: var(--collapse-toggle-height);
    cursor: pointer;
    width: max-content;

    .collapse-icon {
      margin-right: 5px;
      color: var(--text-color-main);
    }

    .collapse-title {
      @include label-style;
      margin-bottom: 0;
      cursor: pointer;
    }

    .collapse-header-end-content {
      display: flex;
      align-items: center;
      margin-inline-start: auto;
      cursor: default;
    }

    .collapse-toggle-icon-wrap {
      order: -1;
      width: 14px;
      height: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: transform ease-in-out 0.05s;
      margin-left: 20px;
      margin-right: 12px;
      cursor: pointer;
      transform: rotate(90deg);
      color: var(--text-color-main);

      &.is-open {
        transform: rotate(-90deg);
        transform-origin: center;
      }
      .seem-icon {
        font-size: var(--font-size-s);
      }
    }
    &:hover {
      color: var(--collapse-title-color-hover);
      .collapse-title {
        color: var(--collapse-title-color-hover);
      }
      .collapse-icon,
      .collapse-toggle-icon-wrap {
        color: var(--text-color-soft);
      }
    }
    .ReactCollapse--content {
      border-top: none;
    }
  }
  &.has-title-border {
    > .ReactCollapse--collapse > .ReactCollapse--content {
      border-top: var(--border-style);
    }
  }
  &.has-padding {
    > .ReactCollapse--collapse > .ReactCollapse--content {
      padding: 0 var(--spacing-5) var(--spacing-3);
    }
  }

  &.borderless {
    border: none !important;
    border-bottom: var(--border-style) !important;

    > .collapse-toggle .collapse-toggle-icon-wrap {
      margin-left: 0;
    }
  }
  &.hide-border-bottom {
    border-bottom: none !important;
  }

  &.is-large {
    > .collapse-toggle {
      margin-block-end: var(--spacing-1);
      cursor: pointer;

      .collapse-title {
        @include subtitle-typography;
        cursor: pointer;
      }

      &:hover {
        .collapse-title {
          color: var(--collapse-title-color-hover);
        }
      }
    }
  }
  &.is-colored {
    > .collapse-toggle {
      .collapse-title {
        color: var(--collapse-title-is-colored-color);
      }
      &:hover {
        .collapse-title {
          color: var(--collapse-title-is-colored-color-hover);
        }
      }
    }
  }

  &.has-header-end-content,
  &.has-right-chevron {
    > .collapse-toggle {
      width: 100%;
      padding-inline-end: var(--spacing-5);
    }
  }

  &.has-right-chevron {
    > .collapse-toggle {
      padding-inline-start: var(--spacing-5);

      .collapse-toggle-icon-wrap {
        order: 0;
        margin-inline: auto 0;
      }

      .collapse-header-end-content ~ .collapse-toggle-icon-wrap {
        margin-inline-start: var(--spacing-4);
      }
    }
  }
}

.collapse-open-scroll-dummy {
  height: 1px;
}
